var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box"},[_c('div',{staticClass:"text"},[_vm._v("占比越大，颜色越深")]),_c('div',{ref:"myEchart",style:({ height: '521px', width: '100%' }),attrs:{"id":"ChinaMap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }